import script from "./ContractTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractTab.vue?vue&type=script&setup=true&lang=js"

import "./ContractTab.vue?vue&type=style&index=0&id=9a796fa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a796fa6"]])

export default __exports__